import React from 'react';
import { MenuIcon, SearchIcon, ShoppingBagIcon, UserIcon } from 'lucide-react';
import { isdinScan } from '../../data/reel';
export type IsdinScreen = 'signup' | 'points' | 'scan' | 'pdp';
interface IsdinPhoneProps {
  screen: IsdinScreen;
}

/** Simplified recreation of the ISDIN Redeem phone screens from the portfolio case. */
export function IsdinPhone({
  screen
}: IsdinPhoneProps) {
  return <div className="relative h-[640px] w-[310px] rounded-[52px] bg-ink p-[10px] shadow-lift" data-id="element-20" data-mp="mjq8tl29dujf">
      <div className="relative h-full w-full overflow-hidden rounded-[42px] bg-white" data-id="element-21" data-mp="ihbnmub4aioz">
        <div className="absolute left-1/2 top-[12px] z-20 h-[30px] w-[100px] -translate-x-1/2 rounded-full bg-ink" data-id="element-22" data-mp="diiefe2v5dum" />
        {screen === 'scan' && <Scan data-id="element-23" data-mp="8iw174n1bxlt" />}
        {screen === 'points' && <Points data-id="element-24" data-mp="2y8zlqt1vah9d" />}
        {screen === 'pdp' && <Pdp data-id="element-25" data-mp="2ya0x6ymsp5rm" />}
        {screen === 'signup' && <Signup data-id="element-26" data-mp="2y6wktdz6f3pv" />}
      </div>
    </div>;
}
function Header() {
  return <div className="flex items-center justify-between px-5 pb-3 pt-[56px] text-ink" data-id="element-27" data-mp="2t8bklejxck1f">
      <span className="flex items-center gap-3" data-id="element-28" data-mp="rya6dzasv3ly">
        <MenuIcon className="h-[16px] w-[16px]" data-id="element-29" data-mp="rve7o8r4oawg" />
        <SearchIcon className="h-[16px] w-[16px]" data-id="element-30" data-mp="vxj2hatbbdko" />
      </span>
      <span className="text-[22px] font-black tracking-[-0.03em]" data-id="element-31" data-mp="hzb8nbrkosdq">ISDIN</span>
      <span className="flex items-center gap-3" data-id="element-32" data-mp="i1falo5wvhbd">
        <UserIcon className="h-[16px] w-[16px]" data-id="element-33" data-mp="mx32ibbs2okk" />
        <ShoppingBagIcon className="h-[16px] w-[16px]" data-id="element-34" data-mp="mzz0fznmld90" />
      </span>
    </div>;
}
function Tile({
  points
}: {
  points: string;
}) {
  return <div data-id="element-35" data-mp="d0zzz4d0knx3">
      <div className="relative h-[120px] rounded-[6px] bg-[#F3F2EF]" data-id="element-36" data-mp="d0rlj818tajs">
        <span className="absolute left-2 top-2 rounded-[3px] bg-white px-1.5 py-[1px] text-[9px] text-ink" data-id="element-37" data-mp="3vehau811h4vs">Bestseller</span>
        <div className="absolute bottom-3 left-1/2 h-[80px] w-[26px] -translate-x-1/2 rounded-b-[3px] rounded-t-[6px] bg-[#E9D9A8]" data-id="element-38" data-mp="48fy7v1fe381" />
      </div>
      <p className="mt-2 text-[11px] text-ink" data-id="element-39" data-mp="3li4airaznss2">K-Ox Eyes</p>
      <p className="mt-1 text-[12px] font-semibold text-ink" data-id="element-40" data-mp="3qdjn7fx9fimw">{points}</p>
      <div className="mt-2 rounded-[3px] bg-ink py-1.5 text-center text-[9px] font-semibold tracking-wider text-white" data-id="element-41" data-mp="37ahpyuq1osjw">ADD</div>
    </div>;
}
function Points() {
  return <div className="h-full bg-white" data-id="element-42" data-mp="2xkg4map2to8o">
      <Header data-id="element-43" data-mp="2xlhmoz4ifazw" />
      <div className="border-y border-line py-4 text-center" data-id="element-44" data-mp="2xky4riev0mlv">
        <p className="text-[11px] text-muted" data-id="element-45" data-mp="2sm4s1s7eczmr">Your points</p>
        <p className="text-[30px] text-ink" data-id="element-46" data-mp="2sjikhskiak4j">500</p>
        <p className="text-[10px] text-muted underline" data-id="element-47" data-mp="3q82icbs0q999">How does it work?</p>
      </div>
      <p className="mt-5 text-center text-[10px] tracking-[0.18em] text-muted" data-id="element-48" data-mp="3l9r5rtac9knc">LOVE ISDIN</p>
      <p className="text-center text-[17px] text-ink" data-id="element-49" data-mp="3gaeij7fk2bk8">Choose your reward</p>
      <div className="mt-4 grid grid-cols-2 gap-3 px-4" data-id="element-50" data-mp="3bbuw75x1uxrc">
        <Tile points="1,100 points" data-id="element-51" data-mp="3bbbe9p7eg9db" />
        <Tile points="1,200 points" data-id="element-52" data-mp="24vr8yr6sib4b" />
      </div>
    </div>;
}
function Pdp() {
  return <div className="h-full bg-white" data-id="element-53" data-mp="24tekrwafv4it">
      <Header data-id="element-54" data-mp="1zwelc483h00o" />
      <div className="bg-[#FCEFB4] px-4 py-2 text-[11px] leading-tight text-ink" data-id="element-55" data-mp="1zvwkeuahlxmf">
        The hack to skip the 20 takes and the ‘soften’ filter in your selfies.
      </div>
      <div className="relative mx-4 mt-3 h-[250px] rounded-[6px] bg-[#F3F2EF]" data-id="element-56" data-mp="kd6wp24ydxsp">
        <div className="absolute bottom-6 left-[38%] h-[170px] w-[44px] rounded-b-[4px] rounded-t-[8px] bg-[#EADBAE]" data-id="element-57" data-mp="pd34lcgru9dj" />
        <div className="absolute bottom-6 left-[56%] h-[120px] w-[36px] rounded-[4px] bg-white ring-1 ring-line" data-id="element-58" data-mp="u3t9kolaca7p" />
      </div>
      <div className="px-4 pt-4" data-id="element-59" data-mp="z1uulf29ujlt">
        <p className="text-[15px] font-semibold text-ink" data-id="element-60" data-mp="z4z1wlb19vgp">K-Ox Eyes</p>
        <p className="text-[11px] text-muted" data-id="element-61" data-mp="132n2a3vhwgfz">Bags & dark circles in 28 days</p>
        <div className="mt-6 rounded-[3px] bg-[#E03131] py-2.5 text-center text-[10px] font-semibold tracking-wider text-white" data-id="element-62" data-mp="184cg1ra3r87r">
          ADD & PICK METHOD
        </div>
      </div>
    </div>;
}
function Signup() {
  return <div className="relative h-full bg-[#9C9C9C]" data-id="element-63" data-mp="39wijiu0vkzav">
      <div className="absolute inset-x-4 top-[160px] rounded-[10px] bg-white p-5 text-center" data-id="element-64" data-mp="3esz45e8v8vj7">
        <p className="text-[16px] text-ink" data-id="element-65" data-mp="194yokqltbkqt">Join for Exclusive Rewards</p>
        <p className="mt-1 text-[10px] text-muted" data-id="element-66" data-mp="146drh01uxh6l">40-second signup for 500 pts</p>
        <div className="mt-4 h-[34px] rounded-[3px] border border-line" data-id="element-67" data-mp="148hrh6wmxw1l" />
        <div className="mt-3 rounded-[3px] bg-ink py-2 text-[9px] font-semibold tracking-wider text-white" data-id="element-68" data-mp="1i5musz4ysgt5">UNLOCK BENEFITS</div>
      </div>
    </div>;
}
function Scan() {
  const corners = ['left-[44px] top-[200px] border-l-[4px] border-t-[4px] rounded-tl-[18px]', 'right-[44px] top-[200px] border-r-[4px] border-t-[4px] rounded-tr-[18px]', 'left-[44px] top-[400px] border-b-[4px] border-l-[4px] rounded-bl-[18px]', 'right-[44px] top-[400px] border-b-[4px] border-r-[4px] rounded-br-[18px]'];
  return <div className="relative h-full bg-[#8FCBB8]" data-id="element-69" data-mp="uer64avt21q4">
      <img src={isdinScan} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-70" data-mp="6py888vmhjsv" />
      <span className="absolute left-1/2 top-[64px] z-10 -translate-x-1/2 whitespace-nowrap rounded-[8px] bg-[#2F6B5A] px-4 py-2 text-[12px] font-medium text-white" data-id="element-71" data-mp="2q7jsbtkjfri">
        Find a code to scan
      </span>
      {corners.map(c => <span key={c} className={`absolute h-[40px] w-[40px] border-white ${c}`} data-id="element-72" data-mp="3tiwpoeip5qyd" />)}
    </div>;
}